import { Array, Boolean, Null, Number, Record, Static, String } from 'runtypes';

import { ArchivButtonRunType } from 'src/models/archiv';
import { IdoButtonRunType } from 'src/models/ido';
import { SpoingButtonRunType } from 'src/models/spoing';
import { StatusButtonRunType, StatusRunType } from 'src/models/status';
import { TaskButtonRunType } from 'src/models/task';

export const DesktopPanelMessageModelMessagesRunType = Record({
	message: String,
	receivedByFullName: String,
	receivedByUserAvatar: String,
	receiverAmount: Number,
	receiverId: Number,
	receiverReadFlag: StatusRunType,
	receiverReadFlags: String,
	receiverStatusFlags: String,
	replyTo: Number,
	sendBy: Number,
	sendByDisplayname: String,
	sendByDisplaynameColor: String,
	sendByFullName: String,
	sendByUserAvatar: String,
	sendDate: Number,
	writtenByTheUser: Boolean,
});

export type DesktopPanelMessageModelMessages = Static<typeof DesktopPanelMessageModelMessagesRunType>;

export const MessageAllUsersRunType = Record({
	Displayname: String,
	ID: Number,
	UserAvatar: String,
	UserDisplayname: String,
});

export type MessageAllUsers = Static<typeof MessageAllUsersRunType>;

const MessageAvailableVirtualGroupMembersRunType = Record({
	fullName: String.Or(Null),
	userId: String,
});

const MessageAvailableVirtualGroupsRunType = Record({
	groupId: String.Or(Number),
	groupName: String,
	groupmembers: Array(MessageAvailableVirtualGroupMembersRunType),
});

const OtherMessageReceiversWithTheirStateRunType = Record({
	receiverDisplayname: String,
	statusButton: StatusButtonRunType,
	userAvatar: String,
});

export const MessageRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	allAvailableUsers: Array(MessageAllUsersRunType),
	allAvailableVirtualGroups: Array(MessageAvailableVirtualGroupsRunType),
	archivButton: ArchivButtonRunType,
	authenticatedUserId: Number,
	communicationPartnerUserId: Number,
	desktopPanelMessageModelMessages: Array(DesktopPanelMessageModelMessagesRunType),
	idoButton: IdoButtonRunType,
	otherMessageReceiversWithTheirState: Array(OtherMessageReceiversWithTheirStateRunType),
	sendByFullName: String,
	sendByUserAvatar: String,
	spoingButton: SpoingButtonRunType,
	statusButton: StatusButtonRunType,
	taskButton: TaskButtonRunType,
});

export type Message = Static<typeof MessageRunType>;
